<style scoped>
.checkin_information_single {
  width: 380px;
  height: 130px;
  background: white;
  box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
  border-radius: 6px 6px 6px 6px;
  padding: 15px 30px 0 30px;
  box-sizing: border-box;
}
.checkin_information_single_icon {
  width: 42px;
  /*height: 42px;*/
}
.checkin_information_single_content {
  display: flex;
  align-items: center;
  margin: 14px 0;
  justify-content: space-between;
}
.checkin_information_single_people {
  font-size: 41px;
  color: #313b5e;
  font-weight: bold;
}
</style>

<template>
  <div class="checkin_information_single">
    <div>{{ title }}</div>
    <div class="checkin_information_single_content">
      <div class="checkin_information_single_people" :style="valueStyle" @click="handleClick">{{ value }}</div>
      <img v-if="icon" :src="icon"  class="checkin_information_single_icon"/>
    </div>
  </div>
</template>


<script>
export default {
  components: {},
  props: {
    valueStyle : {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  created() {

  },
  mounted() {

  },
  methods: {
    handleClick(){
      this.$emit('click');
    }
  }
};
</script>